import React, { useState } from 'react'
import {country} from './codes'
import {Link} from 'react-router-dom'
function Singup() {
  const year = new Date().getFullYear();
  const [singupdata, setsingupdata] = useState({
singup_name:"",
number:"",
email:"",password:"",
  });

  console.log(singupdata.email,singupdata.number,singupdata.singup_name,singupdata.password);
  const adddata=(e)=>{
 const {name,value} = e.target;
 setsingupdata(()=>{
  return{
    ...singupdata,
    [name]:value
  }
 })
  }
  return (
    <>
      <div style={{backgroundColor:'white',height:'800px'}}>
      <div className="image">
        <img src="https://www.demandsphere.com/wp-content/uploads/2018/02/Amazon_logo-1024x358.png" alt="amzon.in" />
        <p>.in</p>
      </div>
      <div className="content">
        <form action="submit">
        <div className="signin">
          <div className='Sign-name'>Create Account</div>
          <br />
          <div className='Signup-name'>Your name</div>
          <input type="text" name="singup_name" id="singup-name" className='input-signup input-name' placeholder='First and last name' onChange={adddata} value={singupdata.singup_name} />
          <div className='Mobileno email-number'>Mobile number</div>
          <div className="number-mo">
            <select name="number" id="country" style={{width:'4.5em'}}>
                <option value="">+91</option>
              {
        country.map((item,index)=>{
          return <option value={item.dial_code} key={index}>{item.name} {item.dial_code}</option>
        })
              }
            </select>
          <input type="number" name="number" id="mobile-no" className='input-signup' placeholder='Mobile number' onChange={adddata} value={singupdata.number} />
          </div>
          <div className='Signup-name'>Email(optional)</div>
          <input type="email" name="email" id="email-signup" className='input-signup input-name' placeholder='First and last name' onChange={adddata} value={singupdata.email} />
          <div className='Signup-name'>Password</div>
          <input type="password" name="password" id="signup-password" className='input-signup input-name' placeholder='At least 6 characters' onChange={adddata} value={singupdata.password} />
          <p className='terms-condition'>To verify your number, we will send you a text message with a temporary code. Message and data rates may apply.</p>
          <button className='continue' style={{marginTop:'1em',height:"2em"}}>Continue</button>
           <hr className='hr-singup' />
           <Link to='../Login' style={{textDecorationLine:'none',color:'black'}}>Already have an account?<span style={{color:'blue'}}> Sign in</span></Link>
          <p className="terms-condition">By creating an account or logging in, you agree to Amazon’s<span className='condition'>Conditon of Use <span style={{color:'black'}}>and</span> Privacy Notice</span></p>
        </div>
        <div className="hr">
        </div>
        </form>
      </div>
     <hr className='hr-down'/>
     <div className="copywright">
      <p className='p-copyw'>Condition</p>
      <p className='p-copyw'>privacyNotice</p>
      <p className='p-copyw'>Help</p>
     </div>
     <div className="copywright">
      <div className='copy-wright'>&copy; 1996-{year},Amaon.com, Inc. or its affiliates</div>
     </div>
    </div>
    </>
  )
}

export default Singup
